<template>
	<div class="chipSim" :class="{ 'ac-bg-black': ac }">
		<header-component
			:is-soon="false"
			img-left="/trocachip/img/setinha-left-white.svg"
			img-right="/trocachip/img/access-white.svg"
			class="header-component"
            :backRoute="true"
			:progression="false"
		/>
		<div class="change_chip_container">
			<h2 class="chipSim_title" :class="{ 'ac-color-white': ac }" v-html="changeESimReasonPage.title"></h2>
			<div class="chipSim_subtitle">
				<p v-html="changeESimReasonPage.subtitle"></p>
			</div>
			<div class="description_chip">
				<div class="info_description" v-for="(benefit, index) of changeESimReasonPage.benefits" :key="index">
					<img src="/trocachip/img/Path2.svg" alt="shutdown-wifi" title="nowifi" />
					<span class="description_name" v-html="benefit"></span>
				</div>
            </div>		
		</div>
		<footer class="chipSim_container-button">
			<button
				class="chipSim_button"
				@click="nextFlow(changeESimReasonPage.firstButton.flow)"
				:class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
			>
				{{ changeESimReasonPage.firstButton.text }}
			</button>
			<button
				class="chipSim_button"
				@click="nextFlow(changeESimReasonPage.secondButton.flow)"
				:class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
			>
				{{ changeESimReasonPage.secondButton.text }}
			</button>
		</footer>
	</div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent';
import { mapState } from 'vuex';
import trackEvent from '@/services/trackEvent';
export default {
	name: 'eSimChip',
	components: {
		HeaderComponent,
	},
	data() {
		return {			
			description: '',
		};
	},
	created(){
		this.sendTracker('motivo esim', 3)
	},
	computed: mapState({
		ac: (state) => state.ac,
		document: (state) => state.document,
		config: (state) => state.config,
		customer: (state) => state.customer,
		initFlow: (state) => state.config['init_flow'],
        changeESimReasonPage: (state) => state.config.changeESimReasonPage || {}
	}),
	methods: {
		nextFlow(flowSelected) {
			flowSelected == this.changeESimReasonPage.firstButton.flow ? this.sendTracker('troca físico por esim') : this.sendTracker('troca esim por esim')
      this.$store.commit("flowSelected", flowSelected);
			this.$router.push({ name: this.getRoute() });
		},
		getRoute() {
			if(!this.config.enable_device_select_eSim)
				return 'documents'

			return 'device-selection'
		},
		sendTracker(eventLabel, eventAction = 2){
			trackEvent.track({
                        'user': {
                            'login': this.customer.login,
                            'loginType': this.customer.loginType,
                            'lineType': this.customer.lineType ,
                            'segment': this.customer.segment,
                            'subSegment':  this.customer.subSegment,
                            'planCode': this.customer.planCode,
                            'planName':  this.customer.planName
                        },
                        'channel': trackEvent.getChannel(),
                        'event-category': 6,
                        'event-label': eventLabel,
						'event-location': 'mvp esim',
                        'event-value': this.isExOi() ? 'oi' : 'tim',
                        'event-status': 'Sucesso',
                        'event-action': eventAction
                    })
		},
		isExOi() {
			if (this.config['init_flow'] === undefined) {
				this.alertError = true;
			}

			return JSON.parse(this.customer.isExOiCustomer);
		}
    },
	
};

</script>

<style lang="scss">
.chipSim {
	width: 100%;
	height: 100%;
	display: block;
	position: absolute;
	background: #003091;
    .change_chip_container {
        width: 90%;
        height: auto;
        margin: 0 5%;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: content-box;
    }
	.chipSim_title {
		width: 100%;
		height: auto;
		font-family: 'timsans_thin';
		display: block;
        margin-block-end: 0 !important;
		margin-top: 96px;
		font-size: 32px;
		font-weight: 300;
		line-height: 39.36px;
		text-align: center;
		color: #FFFFFF;
	}
	.chipSim_container-button {
		width: 100%;
		height: auto;
		margin-top: 28px;
		position: fixed;
		bottom: 0;
		justify-content: center;
		display: grid;
		align-items: center;
		background: #003091;
	}
	.chipSim_button {
		width: 286px;
		height: 52px;
		margin: 0 auto 24px auto;
		border-radius: 26px;
		border: solid 1px #FFFFFF;
		background: none;
		outline: none;
		font-size: 1em;
		text-align: center;
		color: #FFFFFF;
		&:hover {
			cursor: pointer;
			-webkit-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			-moz-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			transition: 1s;
		}
	}
	.description_chip {
		width: 100%;
		display: flex;
		flex-direction: column;
        margin-left: 27px;
	}
	.description_name {
		margin-top: 0 !important;
		padding-left: 18px;
		width: 250px;
		align-items: center;
	}
	.info_description {
		padding-bottom: 24px;
		font-family: "timsans_regular";
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		letter-spacing: -0.20000000298023224px;
		display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
		vertical-align: middle;
		width: 270px;
		float: left;
		color: #ffffff;
	}	
	.chipSim_subtitle {
		width: 252px;
		min-height: 48px;
		margin: 16px auto 23px auto;
		display: block;
		position: relative;
		> p {
			width: 252px;
			height: 48px;
			font-family: 'timsans_regular';
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			font-style: normal;
			line-height: 24px;
			letter-spacing: normal;
			text-align: center;
			color: #ffffff;
			opacity: 60%;
		}
	}
}
@media (min-width: 768px) {
	.chipSim {
		width: 100%;
		height: 100%;
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'container background';
		position: absolute;
		.header-component {
			width: 45%;
			grid-area: header;
		}
		.change_chip_container {
			grid-area: container;
			.chipSim_title {
				width: 416px;
				height: auto;
				display: block;
				margin: 115px auto 0 auto;
				font-family: 'timsans_thin';
				font-size: 2em;
				font-weight: normal;
				line-height: 1.2;
			}
			.chipSim_container-button {
				width: 100%;
				height: auto;
				margin-top: 72px;
				display: block;
				display: grid;
				align-items: center;
				.chipSim_button {
					width: 320px;
					height: 52px;
					margin: 0 auto 32px auto;
					border-radius: 26px;
					font-size: 1em;
				}
			}
		}
	}
}
@media (min-width: 960px) {
	.chipSim {
		width: 100%;
		height: 100%;
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'container background';
		position: absolute;
		.header-component {
			width: 45%;
			grid-area: header;
		}
		.change_chip_container {
			grid-area: container;
			.chipSim_title {
				width: 416px;
				height: auto;
				display: block;
				margin: 115px auto 0 auto;
				font-family: 'timsans_thin';
				font-size: 2em;
				font-weight: normal;
				line-height: 1.2;
			}
			.chipSim_container-button {
				width: 100%;
				height: auto;
				margin-top: 72px;
				display: block;
				display: grid;
				align-items: center;
				.chipSim_button {
					width: 320px;
					height: 52px;
					margin: 0 auto 32px auto;
					border-radius: 26px;
					font-size: 1em;
				}
			}
		}
	}
}
</style>
